import "./tooltip.styles.scss";

const Tooltip = ({ content }) => {
  return <span className="tooltip">{content}</span>;
};

export default Tooltip;
